import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

export default function ThemeToggle({ variant = 'header' }) {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const isHeader = variant === 'header';
  const iconSize = 20;

  if (isHeader) {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        className="xs-btn xs-btn-link p-2 rounded-circle d-flex align-items-center justify-content-center theme-toggle-header"
        aria-label="toggle theme"
        style={{
          width: '38px',
          height: '38px',
          color: theme === 'dark' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.75)',
          textDecoration: 'none',
        }}
      >
        {theme === 'dark' ? <Sun size={iconSize} /> : <Moon size={iconSize} />}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="xs-btn rounded-circle d-flex align-items-center justify-content-center shadow-lg theme-toggle-floating"
      aria-label="toggle theme"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        width: '48px',
        height: '48px',
        backgroundColor:
          theme === 'dark' ? 'var(--portal-theme-secondary)' : 'var(--portal-theme-color)',
        color: '#ffffff',
        zIndex: 9999,
        border: 'none',
        transition: 'all 0.2s ease',
      }}
    >
      {theme === 'dark' ? <Sun size={iconSize} /> : <Moon size={iconSize} />}
    </button>
  );
}
